<template v-doctitle="product.Name">
<div class="card float-e-margins">
  <div class="card-title">
      <h1>{{product.Name}}</h1>
  </div>
  <div class="card-content no-padding" v-if="loaded">
    <div class="container" style="margin:0;">
      <div class="col-md-5" style="padding-right:5%;">
        <div class="row">
          <a @click="zoomModal()">
            <zoomimage
              class="img img-responsive thumbnail"
              style="max-height:330px; width:auto;cursor: zoom-in;"
              :src="selectedImageURL"
              :options="{
                inlinePane: 900,
                containInline: true,
                hoverBoundingBox: true,
                paneContainer: '#zoomContainer',
                handleTouch: false,
              }"
              @show="log('show')"
              @hide="log('hide')"
            ></zoomimage>
          </a>
        </div>
        <div class="row">
          <div class="row category-credit">
            <div v-for="photo in product.Photos" 
            track-by="$index" class="col-sm-3 col-md-3 col-xs-3" style="padding:5px;">
              <div class="thumbnail" style="max-height:100px;cursor:pointer;">
                <a @click="changeSelectedImage($index)">
                  <img class="img-responsive" style="height:100px;"
                  v-lazy="photo.URL" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7" id="zoomContainer">
        <div class="row">
          <div class="product-title">
            {{product.Name}}
          </div>
          <div class="product-desc" style="white-space:pre-line;">
            {{product.Description}}
          </div>
          <hr>
          <div v-if="product.Available && !product.PriceOnRequest" class="product-price">
            {{product.Price | currencyDisplay}}
          </div>
          <div v-if="product.Available && product.PriceOnRequest" class="text-success product-stock">
            Prijs op aanvraag
            <div>
              <button type="button" class="btn btn-success" @click="showRequestModal=true">
              <span class="fa fa-envelope" aria-hidden="true"></span>
              Toon interesse!
              </button>
            </div>
          </div>
          <div v-if="product.Available" class="text-success product-stock">
            Beschikbaar
          </div>
          <div v-if="!product.Available" class="text-danger product-stock">
            Verkocht
          </div>
          <hr>
          <div v-if="product.Available && !product.PriceOnRequest" class="btn-group cart">
            <button type="button" class="btn btn-success" @click="addToShoppingCart()">
              <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span>
              Toevoegen aan winkelwagen
            </button>
          </div>
           <p> 
            <i class="fa fa-envelope"></i>
              <a :href="'mailto:?subject='+ product.Name + ' van Catootjes Kraam&body=Hallo, \nKijk wat ik gevonden heb op https://www.catootjeskraam.nl' + this.$route.path">
              Mail dit door naar een vriend \ vriendin</a>  
          </p>
        <div id="fb-root"></div>
        <!-- Your share button code -->
        <div class="fb-share-button" 
          :data-href="'https://www.catootjeskraam.nl' + this.$route.path" 
          data-layout="button">
        </div>
        </div>
        <hr>
      </div>
    </div>
    <hr class="recommhr">
    <h4>
      Kijk ook eens naar.....
    </h4>
    <div class="row" v-if="!rloaded">
      <div v-for="i in 3" class="col-sm-4 col-xs-12">
        <div class="thumbnail" style="height:100px;">
          <div class="col-xs-2 col-xs-offset-5">
            <img v-else class="img-responsive" src="../assets/img/ajax_loader.gif" style="max-height:200px;">
          </div>
        </div>  
      </div>
    </div>
    <div class="row" v-if="rloaded">
      <div v-for="randomproduct in randomproducts" class="col-md-4 col-sm-6 col-xs-12">
        <product-card :product="randomproduct" ></product-card>
      </div>
    </div>
  </div>

<modal :show.sync="showModal" :width="'50%'" :indicators="true" :indicatorleft="changeImageToPrev" :indicatorright="changeImageToNext">
  <div slot="modal-header">
    <button type="button" class="btn btn-danger pull-right" @click="showModal=false">
      &times;
    </button>
  </div>
  <div slot="modal-body" class="modal-body" style="position: static;">
    <img width="100%" v-lazy="selectedImageURL" :alt="selectedImageURL">
  </div>
  <div slot="modal-footer"></div>
</modal>

<modal :show.sync="showRequestModal" large>
  <div slot="modal-header">
    <button type="button" class="btn btn-danger pull-right" @click="showRequestModal=false">
      &times;
    </button>
    <div class="col-md-12"><h2>Prijs Aanvraag '{{product.Name}}'</h2></div>
  </div>
  <div slot="modal-body" class="modal-body" style="position: static;">
    <div class="row">
      <form class="form-horizontal" name="contact-form" v-on:submit.prevent="SubmitForm">
        <div class="form-group">
          <label for="name" class="col-sm-1 control-label">Naam</label>
          <div class="col-sm-8">
            <input type="text" v-model="customer.Name" class="form-control" id="name" name="name" placeholder="Voor- en Achternaam" required>
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-1 control-label">Email</label>
          <div class="col-sm-8">
            <input type="email" v-model="customer.Email" class="form-control" id="email" name="email" placeholder="voorbeeld@email.nl" required>
          </div>
        </div>
        <div class="form-group">
          <label for="message" class="col-sm-1 control-label">Bericht</label>
          <div class="col-sm-8">
            <textarea class="form-control" v-model="customer.Content" rows="8" name="message" required>Hallo Catootjeskraam,

Ik heb interesse in het product: '{{product.Name}}'.
Graag zou ik de prijs ervan willen weten.

Met vriendelijke groet,
{{customer.Name}}
{{customer.Email}}</textarea>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-4 col-sm-offset-8">
            <input id="submit" id="sendButton" name="submit" type="submit" value="Verzend" class="btn btn-primary">
          </div>
        </div>
        <!-- after save start -->
        <vc-alert v-if="success" type="success" :dismissible="false">
          Contactformulier succesvol verzonden!
        </vc-alert>
        <vc-alert v-if="error" type="danger" :dismissible="false">
           {{errorMessage}}
        </vc-alert>
        <!-- after save end -->
      </form>
    </div> 
  </div>
  <div slot="modal-footer"></div>
</modal>

<modal :show.sync="showCartModal" large :centered="true">
  <div slot="modal-header">
    <button type="button" class="btn btn-danger pull-right" @click="showCartModal=false">
      &times;
    </button>
  </div>
  <div slot="modal-body" class="modal-body" style="position: static;">
    <br>
    <p><strong>{{product.Name}}</strong> is succesvol in je winkelwagen geplaatst. </p>
    <p>Ga naar je winkelwagen om je bestelling af te ronden of klik op verder winkelen</p>
  </div>
  <div slot="modal-footer">
     <div class="modal-footer">
        <button type="button" class="btn btn-default" @click="close">Verder winkelen</button>
        <button type="button" class="btn btn-primary"  onclick="location.href='./bestelling'" >Naar winkelwagen</button>
      </div>
  </div>
</modal>
</div>
</template>

<script>
import store from '../store'
import modal from './Common/Modal'
import callbackalert from './Common/CallbackAlert'
import zoomimage from './Common/ZoomImage'
import ProductCard from './Common/ProductCard'

export default {
  route: {
    canReuse: false
  },
  components: {
    modal,
    'vc-alert': callbackalert,
    zoomimage,
    ProductCard
  },
  data () {
    return {
      store: store,
      product: {},
      selectedImageURL: '',
      selectedImageIndex: 0,
      showModal: false,
      showCartModal: false,
      showRequestModal: false,
      loaded: false,
      rloaded: false,
      customer: {
        Name: '',
        Email: '',
        ProductName: ''
      },
      error: false,
      success: false,
      isValid: true
    }
  },
  methods: {
    changeSelectedImage: function (index) {
      this.selectedImageURL = this.product.Photos[index].URL
      this.selectedImageIndex = index
    },
    addToShoppingCart: function () {
      this.showCartModal = true
      if (!this.containsProduct(this.product, this.store.cart)) {
        this.store.cart.push(this.product)
        sessionStorage.setItem('winkelwagen', JSON.stringify(this.store.cart))
      }
    },
    containsProduct: function (obj, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].ProductId === obj.ProductId) {
          return true
        }
      }
      return false
    },
    zoomModal: function () {
      this.showModal = true
    },
    changeImageToNext: function () {
      this.selectedImageIndex++
      var maxIndex = this.product.Photos.length - 1
      if (this.selectedImageIndex > maxIndex) {
        this.selectedImageIndex = 0
        this.changeSelectedImage(this.selectedImageIndex)
      } else {
        this.changeSelectedImage(this.selectedImageIndex)
      }
    },
    changeImageToPrev: function () {
      this.selectedImageIndex--
      var maxIndex = this.product.Photos.length - 1
      if (this.selectedImageIndex >= 0) {
        this.changeSelectedImage(this.selectedImageIndex)
      } else {
        this.changeSelectedImage(maxIndex)
      }
    },
    close: function () {
      this.showCartModal = false
    },
    SubmitForm: function () {
      if (!this.isValid) {
        this.error = true
        this.errorMessage = 'Valideer je gegevens!'
      } else {
        this.customer.ProductName = this.product.Name
        $.ajax({
          type: 'POST',
          url: store.root + 'api/Contact/priceRequest',
          data: this.customer,
          xhrFields: {
            withCredentials: true
          }
        }).done(function () {
          this.success = true
          this.error = false
          this.customer = {}
          document.getElementById('sendButton').disabled = true
        }.bind(this))
        .fail(function (response) {
          console.log(response)
          this.success = false
          this.error = true
          this.errorMessage = 'Er is een fout opgetreden, probeer later opnieuw!'
        }.bind(this))
      }
    }
  },
  created () {
    $.ajax({
      type: 'GET',
      url: store.root + 'api/products/' + this.$route.params.id,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        this.loaded = true
        this.product = response
        this.selectedImageURL = this.product.Photos[0].URL
      }.bind(this)
    })
    $.ajax({
      type: 'GET',
      url: store.root + 'api/products/random',
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        this.rloaded = true
        this.randomproducts = response
      }.bind(this)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .recommhr {
    margin: 0px;
    height: 1px;
    background-color:#ad1457;
    color:#ad1457;
  }
/*********************************************
            Theme Elements
*********************************************/

.gold{
  color: #FFBF00;
}

/*********************************************
          PRODUCTS
*********************************************/

.product{
  border: 1px solid #dddddd;
  height: 321px;
}

.product>img{
  max-width: 230px;
}

.product-rating{
  font-size: 20px;
  margin-bottom: 25px;
}

.product-title{
  font-size: 20px;
}

.product-desc{
  font-size: 14px;
}

.product-price{
  font-size: 22px;
}

.product-stock{
  font-size: 20px;
  margin-top: 10px;
}

.product-info{
    margin-top: 50px;
}

/*********************************************
          VIEW
*********************************************/

.content-wrapper {
  max-width: 1140px;
  background: #fff;
  margin: 0 auto;
  margin-top: 25px;
  margin-bottom: 10px;
  border: 0px;
  border-radius: 0px;
}

.container-fluid{
  max-width: 1140px;
  margin: 0 auto;
}

.view-wrapper {
  float: right;
  max-width: 70%;
  margin-top: 25px;
}

.container {
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
}

/*********************************************
        ITEM 
*********************************************/

.service1-items {
  padding: 0px 0 0px 0;
  float: left;
  position: relative;
  overflow: hidden;
  max-width: 100%;
  height: 321px;
  width: 130px;
}

.service1-item {
  height: 107px;
  width: 120px;
  display: block;
  float: left;
  position: relative;
  padding-right: 20px;
  border-right: 1px solid #DDD;
  border-top: 1px solid #DDD;
  border-bottom: 1px solid #DDD;
}

.service1-item > img {
  max-height: 110px;
  max-width: 110px;
  opacity: 0.6;
  transition: all .2s ease-in;
  -o-transition: all .2s ease-in;
  -moz-transition: all .2s ease-in;
  -webkit-transition: all .2s ease-in;
}

.service1-item > img:hover {
  cursor: pointer;
  opacity: 1;
}

.service-image-left {
  padding-right: 50px;
}

.service-image-right {
  padding-left: 50px;
}

.service-image-left > center > img,.service-image-right > center > img{
  max-height: 155px;
}

</style>



// WEBPACK FOOTER //
// Product.vue?f22c3386